<template>
    <Layout>
    </Layout>
</template>

<script>
import Layout from "@/views/layouts/Basic.vue";

export default {
    name: "detail_v2",
    components: { Layout },
};
</script>
